import { ColumnDef } from '@tanstack/react-table'

import { Buttons } from '@/components/common/buttons'
import { Table } from '@/components/common/data-display/Table'
import { Call } from '@/services/backend/config/entities'

import { Chamados } from '..'

type Props = {
  data: Call[]
}

export default function Component({ data }: Props) {
  const columns: ColumnDef<(typeof data)[0]>[] = [
    {
      header: 'Nº',
      accessorKey: 'id',
    },
    {
      header: 'Sobre',
      accessorKey: 'about',
      cell: ({ row }) => {
        return (
          <div>
            <div className="text-xs">
              {new Date(row.original.createdAt).toLocaleString()}
            </div>
            <div className="text-sm">{row.original.description}</div>
            <Chamados.Core.TempoAtendimento_ProgressBar
              createdAt={row.original.createdAt}
              status={row.original.status}
            />
          </div>
        )
      },
    },
    {
      header: '',
      accessorKey: 'actions',
      enableSorting: false,
      cell: ({ row }) => (
        <div className="flex justify-end">
          <Buttons.Redirect
            aria-label="Detalhes"
            to={`/app/entity/chamados/${row.original.id}/detalhes`}
          />
        </div>
      ),
    },
  ]

  return (
    <Table
      data={data}
      columns={columns}
      initialSorting={[{ id: 'id', desc: false }]}
    />
  )
}
